var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticClass: "contact-us-outer-wrapper",
      staticStyle: {
        padding: "30px 15px 30px 15px",
        "background-color": "#fff",
        margin: "0"
      }
    },
    [
      _c(
        "el-col",
        {
          staticClass: "contact-us-title-wrapper",
          staticStyle: {
            "background-color": "#003333",
            color: "#fff",
            "border-radius": "10px 10px 0 0",
            height: "50px",
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center"
          },
          attrs: { span: 24 }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "flex-start",
                    "padding-left": "10px"
                  },
                  attrs: { span: 3, xs: 4 }
                },
                [
                  _c("span", { staticClass: "contact-us-title" }, [
                    _vm._v("Contact Us")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "center"
                  },
                  attrs: { span: 6, xs: 8 }
                },
                [
                  _c("span", { staticClass: "contact-us-desc" }, [
                    _vm._v(_vm._s(_vm.openingHours))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "flex-end",
                    "padding-right": "10px"
                  },
                  attrs: { span: 12, xs: 12 }
                },
                [
                  _c("span", { staticClass: "contact-us-desc" }, [
                    _vm._v(_vm._s(_vm.address))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "GmapMap",
            {
              staticClass: "google-map-section",
              staticStyle: { width: "100%", "max-height": "222px" },
              attrs: {
                center: { lat: -34.9217624, lng: 138.6339243 },
                options: {
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: true,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: false
                },
                zoom: 15
              }
            },
            [
              _c("GmapMarker", {
                attrs: {
                  icon: require("../../assets/location.png"),
                  position: { lat: -34.85304, lng: 138.60848 }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37becd46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37becd46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/contactUsSection.vue
// module id = null
// module chunks = 